import request from "@/utils/request";

// 获取微信签名
export function getSignatureWx(params) {
    return request({
        url: "/api/wx/getSignature",
        method: "get",
        params: { data: JSON.stringify(params) },
    });
}


